<template>
  <div>
    <header class="page-header">
      <PageTitle/>
      <div class="filters">
        <formulate-input placeholder="Search" @input="getListData" type="text" v-model="search"></formulate-input>
      </div>
    </header>

    <div class="main-content">
      <div class="pane table-pane" :class="{'loading': isLoading}">
        <div class="table-wrapper">
          <div class="table-element">
            <table class="listData" v-if="!isLoading">
              <thead>
              <tr>
                <th :class="(sortBy === 'user_tracking.id' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.id')" class="id">
                  <div>ID</div>
                </th>
                <th :class="(sortBy === 'user_tracking.user.email' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.user.email')">
                  <div>E-mail</div>
                </th>
                <th :class="(sortBy === 'user_tracking.module' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.module')">
                  <div>Module</div>
                </th>
                <th :class="(sortBy === 'user_tracking.action' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.action')">
                  <div>Actie</div>
                </th>
                <th :class="(sortBy === 'user_tracking.path' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.path')">
                  <div>Pad</div>
                </th>
                <th :class="(sortBy === 'user_tracking.when' ? 'active ' + sortDir : '')" @click="sortTable('user_tracking.when')">
                  <div>Aangemaakt</div>
                </th>
              </tr>
              </thead>

              <tbody v-if="listData.length > 0">
              <tr @click="$router.push({name: 'admin.usertracking', params: { id: listObj.id }})" :key="listObj.id" v-for="listObj in listData">
                <td class="id">{{ listObj.id }}</td>
                <td>{{ listObj.user.email }}</td>
                <td>{{ listObj.module }}</td>
                <td>{{ listObj.action }}</td>
                <td>{{ listObj.path }}</td>
                <td>{{ listObj.when.toFormat('dd LLLL yyyy HH:mm:ss') }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination">
            <div class="results">
              {{ total.min }} - {{ total.max }} van {{ listTotal }} trackings
            </div>

            <div class="buttons">
              <button class="btn-inverse" :disabled="page === 0" @click="prevPage()">Prev</button>
              <button class="btn-inverse" :disabled="listData.length !== perPage" @click="nextPage()">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from '@/services/admin/api.service'
import PageTitle from '@/components/admin/PageTitle'
import { DateTime } from 'luxon'

export default {
  components: { PageTitle },
  data: function () {
    return {
      isLoading: true,
      search: '',
      listData: [],
      page: 0,
      perPage: 25,
      sortBy: 'user_tracking.id',
      sortDir: 'asc',
      listTotal: 0
    }
  },
  async mounted () {
    this.isLoading = true
    await this.getListData()
    this.isLoading = false
  },
  methods: {
    async getListData () {
      await ApiService.fetchUserTrackings({
        page: this.page,
        order_by: this.sortBy,
        order_dir: this.sortDir,
        search: this.search
      }).then(res => {
        this.listData = res.data.users
        this.listData.map(obj => {
          obj.when = DateTime.fromISO(obj.when)
          return obj
        })
        this.listTotal = res.data.total
      })
    },
    async sortTable (sortBy) {
      if (sortBy === this.sortBy) {
        this.sortDir = (this.sortDir === 'asc' ? 'desc' : 'asc')
      }

      this.sortBy = sortBy

      await this.getListData()
    },
    prevPage: async function () {
      if (this.page > 0) {
        this.page--
        await this.getListData()
      }
    },
    nextPage: async function () {
      if (this.listData.length === this.perPage) {
        this.page++
        await this.getListData()
      }
    }
  },
  computed: {
    total: function () {
      const offsetMax = this.perPage * (this.page + 1)
      const offsetMin = offsetMax - this.perPage + 1

      return {
        min: offsetMin,
        max: offsetMax > this.listTotal ? this.listTotal : offsetMax
      }
    }
  }
}
</script>
